import { css } from "@emotion/react";
import { MenuItem, Select, SelectProps } from "@mui/material";
import { useField } from "formik";
import React from "react";
import LabelField from "../label-field";

function SelectField(props: ISelectFieldComponent) {
  const [field, meta, helpers] = useField(props as any);

  const { label, itemLabel, itemValue, ...rest } = props;

  const config: any = {
    ...field,
    ...rest,
    ...{ id: props.name },
  };

  return (
    <div css={styles.contentInput}>
      <LabelField label={props.label} positionLabel={props.positionLabel} />
      <Select css={styles.inputField} {...config} value={field.value ?? -1}>
        <MenuItem value={-1} disabled>
          {props.placeholder}
        </MenuItem>
        {!props.children &&
          props.items?.map((item, i) => (
            <MenuItem key={i} value={itemValue ? item[itemValue] : item.value}>
              {itemLabel ? item[itemLabel] : item.label}
            </MenuItem>
          ))}
        {props?.children && props.children}
      </Select>
      {meta.error && <span css={styles.inputErrors}>{meta.error}</span>}
    </div>
  );
}

export default SelectField;

type ISelectFieldComponent = SelectProps<unknown> & {
  name: string;
  label?: string;
  positionLabel?: "center" | "right" | "left";
  items?: { value: string | number | any; label: string }[] | any[];
  itemLabel?: string;
  itemValue?: string;
  children?: React.ReactNode;
};

export const styles = {
  inputField: css({
    width: "100%",
    outline: "none",
    borderRadius: "50px",
    background: "none",
    color: "var(--color-brand-blue-main)",
    fontFamily: "var(--font-family)",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "var( --fs-body-small)",
    lineHeight: "21px",
    "& .MuiSelect-outlined::focus-visible": {
      border: "0px !important",
    },

    "& .MuiOutlinedInput-notchedOutline": {
      border: "1px solid var(--color-brand-border)",
      top: "-8px",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: "1px solid var(--color-brand-blue-collection-main)",
    },

    "& .MuiOutlinedInput-input": {
      padding: "12px 23px !important",
    },
    "&::placeholder": {
      fontFamily: "var(--font-family)",
      fontWeight: 600,
      fontSize: "var( --fs-body-small)",
      color: "var(--color-brand-blue-main)",
    },
  }),

  contentInput: css({
    width: "100%",
    // minHeight: "80px",
  }),

  inputErrors: css({
    width: "100%",
    color: "var(--color-brand-red-secondary)",
    fontWeight: 500,
    paddingLeft: "10px",
    fontSize: "0.8125rem",
    display: "flex",
    alignItems: "center",
    "& .iconError": {
      fontSize: "0.8125rem",
      marginRight: 3,
    },
  }),
};
